import { Base, withBreakpointObserver } from '@studiometa/js-toolkit';
import Submenu from './Submenu.js';
import { gsap } from 'gsap';

/**
 * Menu component
 */
export default class MenuMobile extends withBreakpointObserver(Base) {
  isOpen = false;
  currentSubmenu = null;

  /**
   * Component Configuration
   */
  static config = {
    name: 'MenuMobile',
    refs: ['items[]', 'wrapper', 'menuPanel'],
    components: {
      Submenu,
    },
    options: {
      activeBreakpoints: {
        default: 'xxs xs s',
        type: String,
      },
    },
  };

  /**
   *
   */
  mounted() {
    this.initTimeline();
  }

  /**
   *
   */
  initTimeline() {
    this.tl = gsap.timeline();
    this.tl.pause();
    this.tl.set(this.$el, { display: 'block' });
    this.tl.fromTo(
      this.$refs.menuPanel,
      {
        'clip-path': 'inset(0% 0% 100% 0%)',
      },
      {
        'clip-path': 'inset(0% 0% 0% 0%)',
        duration: 0.5,
        ease: 'power4.out',
      },
    );

    this.tl.fromTo(
      this.$refs.items,
      {
        opacity: 0,
        yPercent: 50,
      },
      {
        yPercent: 0,
        opacity: 1,
        duration: 0.8,
        stagger: 0.05,
        ease: 'power4.out',
      },
      '>-=0.3',
    );
  }

  /**
   * Simply toggle menu state
   */
  toggle() {
    if (this.isOpen) {
      this.close();
    } else {
      this.open();
    }
  }

  /**
   * Open Menu
   */
  open() {
    document.body.classList.add('menu-is-open');

    if (this.isOpen) {
      return;
    }
    this.isOpen = true;
    this.tl.play(0);
  }

  /**
   * Close menu
   */
  close() {
    document.body.classList.remove('menu-is-open');
    if (this.isOpen) {
      gsap.to(this.$refs.menuPanel, {
        'clip-path': 'inset(0% 0% 100% 0%)',
        duration: 0.5,
        ease: 'power4.out',
        onComplete: () => {
          this.isOpen = false;
          gsap.set(this.$el, { display: 'none' });
        },
      });
    }
  }

  /**
   * Hover on main items
   * @param {object} props Props
   * @param {object} props.target current element
   * @returns {void}
   */
  onItemsClick({ target }) {
    this.$children.Submenu[target.dataset.index].open();
  }
}
